import errorMixin from './logHandler.js'
export default {
  mixins: [errorMixin],
  methods: {
    async getDataSatelliteByNoradId(noradId) {
      const params = {}
      params.noradId = noradId
      let responseInfoSatellite
      let self = this
      await this.$http
        .get(
          'users/' +
            this.currentUser.id +
            '/screeningcatalogueanalysisrequests/infosatellitebynoradid',
          { params }
        )
        .then((response) => {
          responseInfoSatellite = response.data
        })
        .catch((e) => {
          self.displayMessage(
            'Error in loading information of satellite',
            e,
            'notification',
            'error'
          )
        })
      if (typeof responseInfoSatellite === 'object') {
        return responseInfoSatellite
      } else {
        return {}
      }
    },
    async getDataSatellitesByNoradIdList(noradIdList) {
      const params = {}

      params.noradIdList = noradIdList.join(',')
      let responseInfoSatelliteGroup
      let self = this
      await this.$http
        .get(
          'users/' +
            this.currentUser.id +
            '/screeningcatalogueanalysisrequests/infosatellitesbynoradidlist',
          { params }
        )
        .then((response) => {
          responseInfoSatelliteGroup = response.data
        })
        .catch((e) => {
          self.displayMessage(
            'Error in loading informations of satellites',
            e,
            'notification',
            'error'
          )
        })
      if (typeof responseInfoSatelliteGroup === 'object') {
        return responseInfoSatelliteGroup
      } else {
        return {}
      }
    },
    async createSpaceObjectGroup(newSpaceObjectGroup) {
      let self = this
      await this.$http
        .post(
          '/users/' + this.currentUser.id + '/spaceobjectgroups',
          newSpaceObjectGroup
        )
        .then()
        .catch((e) => {
          self.displayMessage(
            'Error when creating a spaceObjectGroup',
            e,
            'notification',
            'error'
          )
        })
    },
    async updateSpaceObjectGroup(newSpaceObjectGroup) {
      let self = this
      await this.$http
        .put(
          '/users/' +
            this.currentUser.id +
            '/spaceobjectgroups/' +
            newSpaceObjectGroup.id,
          newSpaceObjectGroup
        )
        .then()
        .catch((e) => {
          self.displayMessage(
            'Error to update the spaceObjectGroup',
            e,
            'notification',
            'error'
          )
        })
    },
    async deleteSpaceObjectGroup(idSpaceObjectGroup) {
      let self = this
      await this.$http
        .delete(
          '/users/' +
            this.currentUser.id +
            '/spaceobjectgroups/' +
            idSpaceObjectGroup
        )
        .then()
        .catch((e) => {
          self.displayMessage(
            'Error to delete the spaceObjectGroup',
            e,
            'notification',
            'error'
          )
        })
    },
    async deleteAllSpaceObjectGroup() {
      let self = this
      await this.$http
        .delete('/users/' + this.currentUser.id + '/spaceobjectgroups')
        .then()
        .catch((e) => {
          self.displayMessage(
            'Error when deleting all spaceObjectGroup',
            e,
            'notification',
            'error'
          )
        })
    },
    async getSpaceObjectGroup(idSpaceObjectGroup) {
      const params = {}
      let spaceObjectGroup = null
      let self = this
      await this.$http
        .get(
          '/users/' +
            this.currentUser.id +
            '/spaceobjectgroups/' +
            idSpaceObjectGroup,
          {
            params
          }
        )
        .then((response) => {
          spaceObjectGroup = response.data
        })
        .catch((e) => {
          self.displayMessage(
            'Error in loading SpaceObjectGroups',
            e,
            'notification',
            'error'
          )
        })
      return spaceObjectGroup
    },
    async getAllSpaceObjectGroup() {
      const params = {}
      let self = this
      let newListSpaceObjectGroup = null
      await this.$http
        .get('/users/' + this.currentUser.id + '/spaceobjectgroups', {
          params
        })
        .then((response) => {
          newListSpaceObjectGroup = response.data
        })
        .catch((e) => {
          self.displayMessage(
            'Error in loading the catalogue SpaceObjectGroups',
            e,
            'notification',
            'error'
          )
        })
      return newListSpaceObjectGroup
    }
  }
}
